import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import nl from "./nl.json";
import fr from "./fr.json";
import de from "./de.json";
const lang = new URLSearchParams(window.location.search).get("lang") ?? "en";
void i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        nl: { translation: nl },
        fr: { translation: fr },
        de: { translation: de },
    },
    lng: ["en", "nl", "fr", "de"].includes(lang) ? lang : "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
});
export default i18n;
